import { HTTP_INTERCEPTORS, HttpClient, HttpHandler, HttpXhrBackend } from '@angular/common/http';
import { inject, InjectionToken } from '@angular/core';

/**
 * Creates a handler chain consisting of the backend wrapped by all HTTP interceptors
 */
function createInterceptorChain(backend: HttpHandler): HttpHandler {
    // Get all registered interceptors
    const interceptors = inject(HTTP_INTERCEPTORS, { optional: true }) || [];

    // Create the chain of interceptors
    return interceptors.reduceRight(
        (next, interceptor) => ({
            handle: req => interceptor.intercept(req, next),
        }),
        backend
    );
}

/**
 * Custom HttpClient that uses XMLHttpRequest backend
 * but passes through the same interceptor chain as the regular HttpClient
 */
export const HTTP_CLIENT_XHR = new InjectionToken<HttpClient>('HttpClientXhr', {
    providedIn: 'root',
    factory() {
        // Get the XHR backend
        const backend = inject(HttpXhrBackend);

        // Create the handler chain with all interceptors
        const handler = createInterceptorChain(backend);

        // Return a new HttpClient with the interceptor chain
        return new HttpClient(handler);
    },
});
